/* global navigator */
import { call, put, takeEvery } from "redux-saga/effects";
import { FeedbackConstants } from "../constants/feedback.constants";
import { doGraphQLQuery, handleFailure } from "./graphql.saga";
import {
    submitFeedbackSuccess,
    submitFeedbackFailure
} from "../actions/feedback.actions";

export function* submitFeedback() {
    yield takeEvery(FeedbackConstants.SUBMIT_FEEDBACK, doSubmitFeedback);
}

function* doSubmitFeedback({ payload: { body } }) {
    try {
        const userAgent = (navigator && navigator.userAgent) || "";
        const query = `mutation {
            createFeedback(
                body: ${JSON.stringify(body)}
                userAgent: ${JSON.stringify(userAgent)}
            )
        }`;
        yield call(doGraphQLQuery, query);
        yield put(submitFeedbackSuccess());
    } catch (e) {
        yield call(handleFailure, e, submitFeedbackFailure);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/feedback.saga.js